function startFeedbackCardsCarousel() {
	'use strict';

	// get wrapper of all feedback cards
	const wrapperAllFeedbackCards = document.querySelector(
		'.wp-block-cloudavocado-feedback-carousel-wrapper .wrapper-feedback-stack'
	);

	if ( ! wrapperAllFeedbackCards ) {
		return;
	}

	// get all feedback cards
	const allFeedbackCards = wrapperAllFeedbackCards.querySelectorAll(
		'.wp-block-cloudavocado-feedback-card'
	);

	if ( ! allFeedbackCards || allFeedbackCards.length === 0 ) {
		return;
	}

	const rootStyles = window.getComputedStyle( document.documentElement );
	const lg = parseInt(
		rootStyles.getPropertyValue( '--breakpoint-lg' ).trim(),
		10
	);

	// Create carousel-specific state.
	const carouselState = {
		dragStartX: null,
		dragStartY: null,
		isMouseDown: false,
	};

	allFeedbackCards.forEach( ( feedbackCard ) => {
		feedbackCard.addEventListener( 'touchstart', handleDragStart, {
			passive: true,
		} );
		feedbackCard.addEventListener( 'touchmove', handleDragMove, {
			passive: true,
		} );
		feedbackCard.addEventListener( 'mousedown', handleDragStart );
		feedbackCard.addEventListener( 'mousemove', handleDragMove );
		feedbackCard.addEventListener( 'mouseup', handleMouseUp );
	} );

	function handleDragStart( event ) {
		// check if event came from touch or mouse
		if ( 'touches' in event ) {
			carouselState.dragStartX = event.touches[ 0 ].clientX;
			carouselState.dragStartY = event.touches[ 0 ].clientY;
		} else {
			carouselState.isMouseDown = true;
			carouselState.dragStartX = event.clientX;
			carouselState.dragStartY = event.clientY;
		}
	}

	function handleDragMove( event ) {
		if ( ! carouselState.dragStartX || ! carouselState.dragStartY ) {
			return;
		}

		let currentX, currentY; // current drag position

		if ( 'touches' in event ) {
			currentX = event.touches[ 0 ].clientX;
			currentY = event.touches[ 0 ].clientY;
		} else {
			if ( ! carouselState.isMouseDown ) {
				return;
			}
			currentX = event.clientX;
			currentY = event.clientY;
		}

		const deltaX = currentX - carouselState.dragStartX,
			deltaY = currentY - carouselState.dragStartY; // variables for save difference between first clicking and moving

		if (
			( Math.abs( deltaX ) > 0.1 * window.innerWidth ||
				Math.abs( deltaX ) > 80 ) &&
			Math.abs( deltaX ) > Math.abs( deltaY )
		) {
			if ( deltaX > 0 ) {
				showNextCard();
			} else {
				showPrevCard();
			}
			carouselState.dragStartX = carouselState.dragStartY = 0;
		}
	}

	function handleMouseUp() {
		carouselState.isMouseDown = false;
	}

	function showPrevCard( callback ) {
		if (
			wrapperAllFeedbackCards.firstElementChild.classList.contains(
				'transition'
			)
		) {
			return;
		}
		const firstCard = wrapperAllFeedbackCards.firstElementChild;
		const distanceToLeaveScreen = getDistanceToExitRight( firstCard );

		const lastCard = wrapperAllFeedbackCards.lastElementChild;
		lastCard.style.transform = `translateX(${ distanceToLeaveScreen }px) scale(1)`;
		lastCard.style.zIndex = '10';
		lastCard.style.opacity = '1';
		lastCard.style.pointerEvents = 'auto';
		void lastCard.offsetHeight;

		// give transition all cards beside last card
		allFeedbackCards.forEach( ( feedbackCard ) =>
			feedbackCard.classList.add( 'transition' )
		);

		moveDot( -1 ); // moving dot to previous

		void wrapperAllFeedbackCards.offsetHeight; // force reflow so transition sees the starting state
		wrapperAllFeedbackCards.classList.add( 'show-prev-card' );
		window.requestAnimationFrame( () => {
			lastCard.style.transform = 'translateX(0px) scale(1)';
		} );

		const handleTransitionEnd = ( e ) => {
			if ( e.propertyName === 'transform' && e.target === lastCard ) {
				lastCard.removeEventListener(
					'transitionend',
					handleTransitionEnd
				);

				allFeedbackCards.forEach( ( card ) => {
					card.classList.remove( 'transition' );
					card.style.transform = '';
					card.style.zIndex = '';
					card.style.opacity = '';
					card.style.pointerEvents = '';
				} );
				wrapperAllFeedbackCards.classList.remove( 'show-prev-card' );
				wrapperAllFeedbackCards.prepend( lastCard );

				if ( typeof callback === 'function' ) {
					window.requestAnimationFrame( callback );
				}
			}
		};

		lastCard.addEventListener( 'transitionend', handleTransitionEnd );
	}

	function showNextCard( callback ) {
		const firstCard = wrapperAllFeedbackCards.firstElementChild;
		if ( firstCard.classList.contains( 'transition' ) ) {
			return;
		}

		allFeedbackCards.forEach( ( feedbackCard ) =>
			feedbackCard.classList.add( 'transition' )
		);

		firstCard.style.zIndex = '10';
		const distanceToLeaveScreen = getDistanceToExitRight( firstCard );
		firstCard.style.transform = `translateX(${ distanceToLeaveScreen }px) scale(1)`;

		moveDot( 1 ); // moving dot to next

		void wrapperAllFeedbackCards.offsetHeight; // force reflow so transition sees the starting state
		wrapperAllFeedbackCards.classList.add( 'show-next-card' ); // add class for start animation cards

		const handleTransitionEnd = ( e ) => {
			if ( e.propertyName === 'transform' && e.target === firstCard ) {
				firstCard.removeEventListener(
					'transitionend',
					handleTransitionEnd
				);

				allFeedbackCards.forEach( ( card ) => {
					card.classList.remove( 'transition' );
					card.style.transform = '';
					card.style.zIndex = '';
					card.style.opacity = '';
					card.style.pointerEvents = '';
				} );
				wrapperAllFeedbackCards.classList.remove( 'show-next-card' );
				wrapperAllFeedbackCards.appendChild( firstCard );

				if ( typeof callback === 'function' ) {
					window.requestAnimationFrame( callback );
				}
			}
		};

		firstCard.addEventListener( 'transitionend', handleTransitionEnd );
	}

	// count & return distance to move card for leaving screen fully (right side)
	function getDistanceToExitRight( feedbackCard ) {
		const cardRect = feedbackCard.getBoundingClientRect();
		return window.innerWidth - cardRect.left;
	}

	let isBelowLg = window.innerWidth < lg; // variable which save meaning if window was narrower than 1024px for calling func makeDefaultOrderCards()

	window.addEventListener( 'resize', onWindowResize );

	function onWindowResize() {
		if ( isBelowLg && window.innerWidth >= lg ) {
			makeDefaultOrderCards();
			makeDefaultOrderDots();
			isBelowLg = false;
		} else if ( window.innerWidth < lg ) {
			if ( ! isBelowLg ) {
				isBelowLg = true;
			}
		}
	}

	function makeDefaultOrderCards() {
		const rebuildCards = () => {
			wrapperAllFeedbackCards.innerHTML = '';
			allFeedbackCards.forEach( ( feedbackCard ) =>
				wrapperAllFeedbackCards.appendChild( feedbackCard )
			);
		};
		if (
			wrapperAllFeedbackCards.firstElementChild.classList.contains(
				'transition'
			)
		) {
			wrapperAllFeedbackCards.firstElementChild.addEventListener(
				'transitionend',
				rebuildCards,
				{ once: true }
			);
		} else {
			rebuildCards();
		}
	}

	// DOWN STARTS LOGIC FOR CAROUSEL DOTS
	const navigationContainer = document.querySelector(
		'.wp-block-cloudavocado-feedback-carousel-wrapper .carousel-nav'
	);

	if ( ! navigationContainer ) {
		return;
	}

	function renderDots( container, count ) {
		container.innerHTML = '';
		for ( let i = 0; i < count; ++i ) {
			const dot = document.createElement( 'button' );
			dot.setAttribute(
				'aria-label',
				`Go to customer feedback ${ i + 1 }`
			);
			dot.className = `carousel-dot ${ i === 0 ? 'active' : '' }`;
			dot.dataset.index = i;
			container.appendChild( dot );
		}
	}

	renderDots( navigationContainer, allFeedbackCards.length ); // create all dots and add it on page

	// add for all dots event for clicking on dots as a result moving card
	const allDots = navigationContainer.querySelectorAll( '.carousel-dot' );

	if ( ! allDots ) {
		return;
	}

	allDots.forEach( ( carouselDot ) =>
		carouselDot.addEventListener( 'click', ( event ) => goToCard( event ) )
	);

	function goToCard( event ) {
		// check if some animation started working
		if (
			wrapperAllFeedbackCards.classList.contains( 'show-next-card' ) ||
			wrapperAllFeedbackCards.classList.contains( 'show-prev-card' )
		) {
			return;
		}
		const indexActiveDot = [ ...allDots ].findIndex( ( dot ) =>
			dot.classList.contains( 'active' )
		);
		const indexClickedDot = parseInt( event.target.dataset.index );
		let steps = indexClickedDot - indexActiveDot;

		if ( ! steps ) {
			return;
		}

		const direction = steps > 0 ? 'next' : 'prev';
		if ( 0 > steps ) {
			steps *= -1;
		}
		navigateStepByStep( direction, steps );
	}

	// recursive function for moving cards and waiting for finished card animation before again calling moving
	function navigateStepByStep( direction, stepsLeft ) {
		if ( ! stepsLeft ) {
			return;
		}

		if ( direction === 'next' ) {
			showNextCard( () =>
				navigateStepByStep( direction, stepsLeft - 1 )
			);
		} else {
			showPrevCard( () =>
				navigateStepByStep( direction, stepsLeft - 1 )
			);
		}
	}

	function moveDot( step ) {
		let indexActiveDot = [ ...allDots ].findIndex( ( dot ) =>
			dot.classList.contains( 'active' )
		);
		allDots[ indexActiveDot ].classList.remove( 'active' );
		indexActiveDot =
			( ( indexActiveDot + step >= 0 ? indexActiveDot : allDots.length ) +
				step ) %
			allDots.length;
		allDots[ indexActiveDot ].classList.add( 'active' );
	}

	function makeDefaultOrderDots() {
		for ( let i = 0; i < allDots.length; ++i ) {
			if ( i && allDots[ i ].classList.contains( 'active' ) ) {
				allDots[ i ].classList.remove( 'active' );
				allDots[ 0 ].classList.add( 'active' );
				break;
			}
		}
	}
}

// Initialize carousel when DOM is ready.
document.addEventListener( 'DOMContentLoaded', startFeedbackCardsCarousel );
